import React from "react";
import { Typography, Card } from "antd";

const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#f7fafc] py-10 px-4">
      <div className="max-w-4xl mx-auto">
        <Card className="rounded-xl shadow-sm border border-gray-100">
          <Typography className="[&_.ant-typography]:!mb-2 [&_.ant-typography]:!mt-0">
            <Title level={2} className="!text-[#1c5a85] !mb-1">
              Privacy Policy for Eye on Wellness
            </Title>

            <Paragraph className="mt-6">
              Eye on Wellness respects your privacy and is committed to protecting your
              personal information. This Privacy Policy explains how we collect, use,
              and safeguard your information when you use our mobile application.
            </Paragraph>

            <Title level={4}>1. Information We Collect</Title>
            <Paragraph>We may collect the following types of information:</Paragraph>
            <Paragraph>
              <strong>Personal Information</strong>
              <br />
              Name
              <br />
              Email address
              <br />
              Account login details
            </Paragraph>
            <Paragraph>
              <strong>Wellness Information</strong>
              <br />
              Images of your eye (iris photos) submitted through the app
              <br />
              Generated wellness reports and insights
            </Paragraph>
            <Paragraph>
              <strong>Usage Information</strong>
              <br />
              App activity and interactions
              <br />
              Device information (such as device type, operating system)
            </Paragraph>
            <Paragraph>
              <strong>Payment Information</strong>
              <br />
              All payments are processed through Stripe.
              <br />
              We do not collect or store your payment details.
            </Paragraph>

            <Title level={4}>2. How We Use Your Information</Title>
            <Paragraph>We use your information to:</Paragraph>
            <Paragraph>
              Provide personalized wellness reports and insights
              <br />
              Improve app functionality and user experience
              <br />
              Communicate with you regarding your account or reports
              <br />
              Maintain security and prevent misuse
            </Paragraph>

            <Title level={4}>3. Wellness Disclaimer</Title>
            <Paragraph>
              Information provided within the app is for educational and informational
              purposes only and is not intended as medical advice, diagnosis, or treatment.
              You should always consult a qualified provider for wellness concerns.
            </Paragraph>

            <Title level={4}>4. Data Storage &amp; Security</Title>
            <Paragraph>
              We implement reasonable security measures to protect your information. Your
              data is stored securely and access is limited to authorized systems and
              personnel.
            </Paragraph>
            <Paragraph>
              However, no method of transmission over the internet is 100% secure, and we
              cannot guarantee absolute security.
            </Paragraph>

            <Title level={4}>5. Sharing of Information</Title>
            <Paragraph>We do not sell your personal information.</Paragraph>
            <Paragraph>We may share information only in the following cases:</Paragraph>
            <Paragraph>
              With service providers who help operate the app (e.g., hosting, analytics,
              email delivery)
              <br />
              If required by law or legal process
              <br />
              To protect our rights, users, or the public
            </Paragraph>

            <Title level={4}>6. Data Retention</Title>
            <Paragraph>
              We retain your information only as long as necessary to provide our services
              or comply with legal obligations. You may request deletion of your data at
              any time (see Section 7).
            </Paragraph>

            <Title level={4}>7. Data Deletion Requests</Title>
            <Paragraph>
              If you would like to delete your account, please do so on website. You can
              always resubscribe.
              <br />
              We will process your request within a reasonable timeframe.
            </Paragraph>

            <Title level={4}>8. Children&apos;s Privacy</Title>
            <Paragraph>
              This app is not intended for children under the age of 13. We do not
              knowingly collect personal information from children.
            </Paragraph>

            <Title level={4}>9. Third-Party Services</Title>
            <Paragraph>
              The app may use third-party services (such as analytics or email providers)
              that collect information in accordance with their own privacy policies.
            </Paragraph>

            <Title level={4}>10. Changes to This Policy</Title>
            <Paragraph>
              We may update this Privacy Policy from time to time. Updates will be posted
              within the app with a revised effective date.
            </Paragraph>

            <Title level={4}>11. Contact Us</Title>
            <Paragraph>
              If you have any questions about this Privacy Policy, please contact us:
              <br />
              Email:{" "}
              <a href="mailto:wellnessmel869@gmail.com">wellnessmel869@gmail.com</a>
              <br />
              Company Name: Eye On Wellness
            </Paragraph>
          </Typography>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
